// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bf7b3a80","239":"aa48ba6c","453":"6fb05a0d","455":"533fe5a9"}[chunkId] + ".chunk.js";
};